export default "__VITE_ASSET__BmZu0rcu__"